import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Location
import LocationImage from 'components/location/image';
import Address from 'components/location/address';

// Booking
import BookAgain from 'components/location/buttons/book-again';

import { Location } from 'models/locations';
import Booking from 'models/booking';

import VisibilitySensor from 'react-visibility-sensor';
import { pageProps } from 'lib/analytics/page-properties';
import { BUTTON_IMPRESSION, BUTTON_CLICK } from 'lib/analytics/events';
import Brand from 'models/brand';

const propTypes = {
  location: PropTypes.instanceOf(Location).isRequired,
  recentBooking: PropTypes.instanceOf(Booking).isRequired,
  app: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  analyticsPosition: PropTypes.number,
};

const defaultProps = {
  analyticsPosition: 0,
};

class FrequentLocation extends Component {
  constructor(props) {
    super(props);

    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onVisibilityChange(isVisible) {
    const { trackEvent, app, location, recentBooking, analyticsPosition } = this.props;
    if (isVisible) {
      const pageProperties = pageProps({
        app,
        LocationID: location.id,
        LocationAddress: location.address,
        LastParkedDate: recentBooking.startTime.tz(location.timezone).format('ddd MMM D, YYYY'),
      });
      trackEvent({
        ...BUTTON_IMPRESSION,
        ...pageProperties,
        name: 'BookAgain',
        position: analyticsPosition.toString(),
      });
    }
  }

  onClick(location) {
    const { trackEvent, app, recentBooking, analyticsPosition } = this.props;
    const pageProperties = pageProps({
      app,
      LocationID: location.id,
      LocationAddress: location.address,
      LastParkedDate: recentBooking.startTime.tz(location.timezone).format('ddd MMM D, YYYY'),
    });
    trackEvent({
      ...BUTTON_CLICK,
      ...pageProperties,
      name: 'BookAgain',
      position: analyticsPosition.toString(),
    });
  }

  render() {
    const { location, recentBooking, brand } = this.props;
    return (
      <div className="frequent-location">
        <div className="shadowed-xs row mock-table-row">
          <div className="col-sm-2 col-xs-5 padding-right-0-xs">
            <LocationImage
              location={location}
              type="thumbnail"
            />
          </div>
          <div className="col-sm-3 col-xs-7 padding-left-0-xs">
            <Address
              location={location}
            />
          </div>
          <div className="col-sm-4 hidden-xs">
            <div className="grid-header weak top middle-align">Last parked here on</div>
            <div className="grid-header weak">{recentBooking.startTime.tz(location.timezone).format('ddd MMM D, YYYY')}</div>
          </div>
          <div className="col-sm-3 hidden-xs">
            <VisibilitySensor onChange={v => this.onVisibilityChange(v)} partialVisibility>
              <div onClick={() => this.onClick(location, recentBooking)}>
                <BookAgain
                  location={location}
                  venueID={location.venueId}
                  brand={brand}
                />
              </div>
            </VisibilitySensor>
          </div>
        </div>
        <div className="visible-xs row">
          <div className="col-xs-6" />
          <div className="col-xs-6 padding-left-0-xs">
            <VisibilitySensor onChange={v => this.onVisibilityChange(v)} partialVisibility>
              <div onClick={() => this.onClick(location, recentBooking)}>
                <BookAgain
                  location={location}
                  venueID={location.venueId}
                  brand={brand}
                />
              </div>
            </VisibilitySensor>
          </div>
        </div>
      </div>
    );
  }
}

FrequentLocation.propTypes = propTypes;
FrequentLocation.defaultProps = defaultProps;
export default FrequentLocation;
